import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ConverterFindInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-find.dto';
import { ConverterStatusEnum } from '@zaoblako/shared/modules/pacs/enums/converter-status.enum';
import { ConverterService } from '@zaoblako/web/core/services/control/converter.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-converter-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './converter-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConverterSingleSelectComponent implements OnInit {
  @Input() public converters: ConverterFindInterface[] = [];
  @Input() public selectedConverter: ConverterFindInterface;

  @Output() public selectedConverterChange = new EventEmitter<ConverterFindInterface>();

  @Input() public customRequest = false;
  @Input() public sort: string;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = false;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public isFloatLabel = false;
  @Input() public placeholder = '\u00A0';
  @Input() public appendTo: string;

  @Input() public statuses: ConverterStatusEnum[] = [];

  public constructor(
    private readonly converterService: ConverterService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.PHYSICAL_ACCESS_CONTROL?.enabled
    ) {
      this.converterService.findAll({ list: true, status: this.statuses }).subscribe({
        next: (converters) => {
          this.converters = converters;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
